import { render, staticRenderFns } from "./DataParse.vue?vue&type=template&id=47cf3a4c&scoped=true"
import script from "./DataParse.vue?vue&type=script&lang=js"
export * from "./DataParse.vue?vue&type=script&lang=js"
import style0 from "./DataParse.vue?vue&type=style&index=0&id=47cf3a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf3a4c",
  null
  
)

export default component.exports